const plans = [
  { id: 1, title: "Primera Inscripción Vehicular" },
  { id: 2, title: "Certificado de Homologación Electrónico (CHI-e)" },
  { id: 3, title: "Seguro Obligatorio de Accidentes Personales (SOAP)" },
  { id: 4, title: "Permiso de Circulación Vehicular (PCV)" },
  { id: 5, title: "TAG" },
  { id: 6, title: "Billetera Electrónica" },
];

export const lastLicenseNumberAvailable = new Array(10)
  .fill(0)
  .map((_, index) => ({ id: `${index}`, name: index }));

export const plansAvailable = [
  {
    id: 1,
    title: "Plan Básico",
    price: "",
    isBestSelling: false,
    needLicenseNumber: false,
    quoteKey: "monto_basico",
    type: "BASICO",
    items: [plans[0], plans[5]],
  },
  {
    id: 2,
    title: "Plan Full",
    price: "",
    isBestSelling: false,
    needLicenseNumber: true,
    quoteKey: "monto_full",
    type: "FULL",
    items: plans,
  },
  {
    id: 3,
    title: "Plan Estándar",
    price: "",
    isBestSelling: false,
    needLicenseNumber: true,
    quoteKey: "monto_estandar",
    type: "ESTANDAR",
    items: [plans[0], plans[1], plans[2], plans[3], plans[5]],
  },
];

export const vehicleTypeAvailable = [
  // 'AUTOMOVIL',
  // 'STATION WAGON',
  "FURGON",
  // 'CAMIONETA',
  // 'MINIBUS',
  // 'JEEP',
  // 'LIMUSINA',
  "BUS",
  // 'MICROBUS',
  // 'OMNIBUS',
  "TRACTOR",
  "MAQUINA AGRICOLA",
  // 'CASA RODANTE',
  // 'MOTORIZADA',
  "MAQUINA INDUSTRIAL",
  // 'AMBULANCIA',
  // 'CARROBOMBA',
  "CHASIS CABINADO",
  // 'COCHE MORTUORIO',
  // 'BUGGI',
  // 'TRACTOR ANFIBIO',
  "CAMION",
  // 'TRACTOCAMION',
  // 'REMOLQUE',
  // 'SEMIREMOLQUE',
  "BICICLETA MOTOR",
  "BICIMOTO",
  "CUADRIMOTO",
  "MOTO",
  "MOTORIZADA",
  "TRICICLO MOTOR",
  "TRIMOTO",
  // 'BICIMOTO',
  // 'TRIMOTO',
  // 'CUADRIMOTO',
  // 'BICICLETA MOTOR',
  // 'TRICICLO MOTOR'
];

export const gasTypes = [
  { value: "NO_INFORMADO", label: "NO INFORMADO" },
  { value: "GASOLINA", label: "GASOLINA" },
  { value: "DIESEL", label: "DIESEL" },
  {
    value: "GNC_GAS_NATURAL_COMPRIMIDO",
    label: "GNC (GAS NATURAL COMPRIMIDO)",
  },
  {
    value: "GLP_GAS_LICIADO_DE_PETROLEO",
    label: "GLP (GAS LICIADO DE PETROLEO)",
  },
  { value: "ELECTRICO", label: "ELECTRICO" },
  { value: "DUAL_GNC_ELECTRICO", label: "DUAL (GNC/ELECTRICO)" },
  { value: "DUAL_GLP_GASOLINA", label: "DUAL (GLP/GASOLINA)" },
  // { value: "DUAL_GLC_GASOLINA", label: "DUAL (GLC/GASOLINA)" },
  { value: "DUAL_ELECTRICO_GASOLINA", label: "DUAL (ELECTRICO/GASOLINA)" },
  { value: "HIBRIDO_DIESEL_ELECTRICO", label: "HIBRIDO (DIESEL-ELECTRICO)" },
];

const convertToOptionType = (items) =>
  items.map((label) => ({ value: label, label }));

export const vehicleType = convertToOptionType(vehicleTypeAvailable);
export const personType = convertToOptionType(["NATURAL", "JURÍDICA"]);
export const dispatchPlace = convertToOptionType([
  "DOMICILIO",
  "LOCAL DE COMPRA",
]);

export const billType = convertToOptionType([
  "Factura",
  "Nota de Crédito",
  "DS55",
]);
